import { ProposalStateEnum } from "../_enums/proposal-state"
import { IOfferContractsWithProductSeats } from "./offer-contracts-with-product"

export interface IProductGroup {
    currentSeats: number,
    licenseNumber: number,
    name: string,
    recurringPrice: number,
    priceToRenewal: number,
    productId: string,
    parentProductId: string,
    itemInfoId: string,
    oneTimeDiscountAmount: number,
    recurringDiscountPercent: number,
    licenseType: string,
    allowCustomerSeatAlteration: boolean,
    isAutodeskProduct: boolean,
    newSeats: number, //frontend only
    isLastProductInGroup: boolean, // frontend only
    itemType: number,  // frontend only
    itemTypeName: string,  // frontend only
    indicators: IndicatorEnum[] // frontend only
}
export interface ISalesProposal {
    cart: IProductGroup[],
    customerCart: IProductGroup[],
    customerEmails: string[],
    noteToCustomer: string,
    noteFromCustomer: string,
    internalNote: string,
    contract: IOfferContractsWithProductSeats | null,
    proposalNumber: string,
    companyNumber: string,
    expirationDate: Date,
    state: ProposalStateEnum,
    companyName: string,
    salesAgent: {
        email: string,
        name: string,
        phoneNumber: string,
        profilePictureUrl: string,
        companyName: string,
        companyNumber: string,
        orgNr: string
    }
}

export enum IndicatorEnum {
    RecurringDiscount,
    OneTimeDiscount,
    RecurringPrice,
    PriceToRenewal
}